export default "__VITE_ASSET__7ayqVeVF__"